import React from 'react';
// eslint-disable-next-line no-restricted-imports
import { useRouter } from 'next/router';
import styled from '@emotion/styled';
import { Grid, GridItem } from '../../../../../ui';
import { IBlogItem } from '../../../../shared/api/contentful/types/IBlogItem';
import NewsCard from '../NewsCard';
import { removePaginationFromPath } from '../../../helpers/removePaginationFromPath';
import NewsCardNoImage from '../../../../../../assets/icons/no-image.svg?reference';
import { NoSearchResultsMessage } from '../NoSearchResultsMessage';
import Responsive from '../../../../../ui/utils/Responsive';
import truncateText from '../../../helpers/truncateText';

interface IHighlighedNewsStoryProps {
	blogs: IBlogItem[];
}

export const BlogsList = ({ blogs }: IHighlighedNewsStoryProps) => {
	const router = useRouter();
	const asPath = removePaginationFromPath(router.asPath);
	const isTabletXL = Responsive.useMatchesBreakpoint('tabletXL');

	return (
		<StyledGrid>
			{blogs.length === 0 && <NoSearchResultsMessage />}

			{blogs.map((item) => {
				const firstImage = item.images?.[0]?.fields;
				const imageSrc = firstImage?.file.url || NewsCardNoImage;

				return (
					<StyledGridItem columns={[6, { mobileXL: 12 }]} key={item.slug}>
						<NewsCard
							variant={isTabletXL ? 'vertical' : 'horizontal'}
							title={item.title}
							summaryTruncated
							summary={truncateText(item.body, 200)}
							publicationDate={item.publicationDate}
							linkHref={`${asPath}/item/${item.slug}`}
							imageSource={imageSrc}
							category={item.category}
							categoryLabelLeftTop
						/>
					</StyledGridItem>
				);
			})}
		</StyledGrid>
	);
};

const StyledGrid = styled(Grid.withComponent('ul'))`
	padding-left: 0;
	list-style: none;
`;

const StyledGridItem = styled(GridItem.withComponent('li'))`
	display: flex;
	padding-left: 0;
`;
